import {
  apiClient,
  applyHeaders,
  buildHeaders,
  getEnv,
} from "@bkry/bowline-utils";
import { call, put, takeEvery } from "redux-saga/effects";
import { storeIncluded } from "../dictionarySagas";
import { actions } from "./index";

// export function* list(action) {
//   let headers = yield buildHeaders();
//   let { projectId, pageNum, itemNum, sorting, filters } = action.payload;
//   try {
//     const SwaggerClient = yield call(apiClient);
//     const payload = yield call(
//       SwaggerClient.apis.ProjectDesigns.listProjectDesignsForProject,
//       {
//         project_id: projectId,
//         page: pageNum,
//         items: itemNum,
//         sorting: JSON.stringify(sorting),
//         filters: JSON.stringify(filters),
//       },
//       { requestInterceptor: applyHeaders(headers) }
//     );
//     if (payload.obj.included)
//       yield* storeIncluded({ payload: payload.obj.included });
//     yield put(actions.listSuccess(payload ));
//   } catch (e) {
//     yield put(actions.listFail(e ));
//   }
// }

export function* create(action) {
  let headers = yield buildHeaders();
  let { projectId, ...requestBody } = action.payload;
  try {
    const SwaggerClient = yield call(apiClient);
    let payload = yield call(
      SwaggerClient.apis.ProjectDesigns.createProjectDesignForProject,
      { project_id: projectId },
      {
        requestInterceptor: applyHeaders(headers),
        requestBody,
      }
    );

    if (payload.obj?.included)
      yield* storeIncluded({ payload: payload.obj.included });
    yield put(actions.createSuccess(payload.obj.data));
  } catch (e) {
    yield put(actions.createFail({ message: e.message, ...e }));
  }
}
/** Show Saga
 *  @description: connects to the showPage operation
 *  @param {number} action.payload the Page id
 */
export function* show(action) {
  let headers = yield buildHeaders();
  const { projectId } = action.payload;
  try {
    const SwaggerClient = yield call(apiClient);
    const payload = yield call(
      SwaggerClient.apis.ProjectDesigns.showProjectDesignForProject,
      {
        project_id: projectId,
      },
      {
        requestInterceptor: applyHeaders(headers),
      }
    );
    if (payload.obj?.included)
      yield* storeIncluded({ payload: payload.obj.included });
    yield put(actions.showSuccess(payload.obj.data));
  } catch (e) {
    yield put(actions.showFail({ message: e.message, ...e }));
  }
}

export function* update(action) {
  const { projectId, ...requestBody } = action.payload;
  let headers = yield buildHeaders();
  try {
    const SwaggerClient = yield call(apiClient);
    let payload = yield call(
      SwaggerClient.apis.ProjectDesigns.updateProjectDesignForProject,
      { project_id: projectId },
      {
        requestInterceptor: applyHeaders(headers),
        requestBody,
      }
    );

    if (payload.obj?.included)
      yield* storeIncluded({ payload: payload.obj.included });

    yield put(actions.updateSuccess(payload.obj.data));
  } catch (e) {
    yield put(actions.updateFail({ message: e.message, ...e }));
  }
}

export function* uploadFont(action) {
  const REACT_APP_API_SERVER = getEnv("REACT_APP_API_SERVER");
  const { projectId, fonts } = action.payload;
  let headers = yield buildHeaders();

  const { "Content-Type": contentType, ...authHeaders } = headers;

  const formData = new FormData();
  for (let i = 0; i < fonts.length; i++) {
    formData.append("fonts[]", fonts[i]);
  }

  try {
    const response = yield fetch(
      `${REACT_APP_API_SERVER}/api/v1/projects/${projectId}/project_design/upload_font`,
      {
        headers: authHeaders,
        method: "PUT",
        body: formData,
      }
    );

    const json = yield response.json();

    if (response.ok) {
      yield put(actions.uploadFontSuccess(json.data));
    } else {
      yield put(actions.uploadFontFail(json));
    }
  } catch (e) {
    yield put(actions.uploadFontFail(e));
  }
}

/**
 * Saga Watchers
 * The exported list of sagas registered. When one of the action types is dispatched
 * the related worker saga is invoked.
 * Each saga is executed in a different thread
 */
function* projectDesignsSagas() {
  // yield takeEvery(actions.list, list);
  yield takeEvery(actions.show, show);
  yield takeEvery(actions.update, update);
  yield takeEvery(actions.create, create);
  yield takeEvery(actions.uploadFont, uploadFont);
}
export default projectDesignsSagas;
